export const FAQS_SIGNS_POOL_NEEDS_RESURFACING: {
  question: string;
  answer: string;
}[] = [
  {
    question: "How do I know when my pool needs resurfacing?",
    answer:
      "Resurfacing may be worth considering when the interior finish has widespread roughness, pitting, erosion, flaking, material loss, repeated failed repairs, or several finish-related symptoms occurring together. The surface should still be evaluated before the final scope is chosen.",
  },
  {
    question: "Does a rough pool surface mean it needs resurfacing?",
    answer:
      "Not always. Broad deterioration may support resurfacing, but scaling, chemical conditions, installation variables, or localized damage can also affect texture. The type, cause, and extent of the roughness matter.",
  },
  {
    question: "Do pool stains mean the finish is failing?",
    answer:
      "No. Stains and discoloration can have several causes. Persistent staining may be an aesthetic reason to resurface, especially when other deterioration is present, but color alone does not prove surface failure.",
  },
  {
    question: "Do cracks mean my pool needs resurfacing?",
    answer:
      "Not necessarily. Fine surface markings, finish cracks, and cracks related to deeper movement cannot be reliably distinguished through a generic checklist. Widening, recurring, displaced, or leaking cracks should be evaluated before resurfacing is selected.",
  },
  {
    question: "Will resurfacing fix a pool that is losing water?",
    answer:
      "Not automatically. Water loss can involve the surface, plumbing, fittings, equipment, penetrations, cracks, evaporation, or other conditions. The source should be investigated before resurfacing is presented as the solution.",
  },
  {
    question: "How old should a pool be before it is resurfaced?",
    answer:
      "There is no universal age that applies to every pool. Finish type, installation, startup, water chemistry, maintenance, use, repairs, and existing conditions can all affect performance. Condition matters more than the calendar alone.",
  },
  {
    question: "Is pool mottling a sign of failure?",
    answer:
      "Not by itself. Cementitious finishes can show inherent shading, mottling, color variation, and differences in aggregate appearance. The condition should be evaluated alongside texture, material loss, changes over time, and other symptoms.",
  },
  {
    question: "Should I resurface or remodel my pool?",
    answer:
      "Resurfacing may fit when the interior finish is the primary concern. A broader remodel may make more sense when tile, coping, decking, features, or design goals are also involved. Unexplained water loss, movement, or recurring cracks should be evaluated before either scope is finalized.",
  },
];

export const TOC_SIGNS_POOL_NEEDS_RESURFACING = [
  {
    id: "quick-check",
    title: "Quick Check: Resurface, Monitor, or Evaluate First?",
  },
  {
    id: "seven-signs",
    title: "Seven Signs Resurfacing May Be Worth Considering",
  },
  {
    id: "when-the-symptom-is-inconclusive",
    title: "When the Symptom Is Inconclusive",
  },
  {
    id: "signs-the-problem-may-go-deeper",
    title: "Signs the Problem May Go Deeper Than Resurfacing",
  },
  {
    id: "normal-variation-vs-deterioration",
    title: "Normal Variation vs. Deterioration",
  },
  {
    id: "why-pool-age-alone-is-not-proof",
    title: "Why Pool Age Alone Is Not Proof",
  },
  {
    id: "what-to-do-before-choosing-resurfacing",
    title: "What to Do Before Choosing Resurfacing",
  },
  { id: "frequently-asked-questions", title: "Frequently Asked Questions" },
];
